<div class="container-fluid">

  <div class="row">
    <div class="col-xl-12">
      <h1 class="page-hd">Document Verification <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Raise
        Dispute</h1>
      <div class="content-wrap">
        <div class="table-responsive">
          <table class="ui celled table hover" [dtTrigger]="dtTrigger1" datatable [dtOptions]="dtOptions">
            <thead>
              <tr>
                <th>Select</th>
                <th>Full Name</th>
                <th>Application Id</th>
                <th>Seat No.</th>
                <!-- <th>Passing Month</th> -->
                <th>Passing Year</th>
                <th>Stream</th>
                <th>Branch</th>
                <th>Semester</th>
                <th>Document</th>
                <th>Status</th>
                <th>Download Invoice</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of request">
                <td><input type="radio" class="dispute-radio" name="dispute" (click)="getApplicationId(data.application_id, data.id)"></td>
                <td>{{data.first_name + " " + data.last_name}}</td>
                <td>{{data.application_id}}</td>
                <td>{{data.enroll_no}}</td>
                <td>{{data.monthOfPassing}}/{{data.year}}</td>
                <td>{{data.stream_name}}</td>
                <td>{{data.branch_nm}}</td>
                <td>{{data.semester}}</td>
                <td>{{data.doc_name}}</td>
                <!-- <td>{{data.doc_status}}</td> -->
                <td *ngIf=" data.doc_status=='UN_Approved_Pass' || data.doc_status=='UN_Approved_Fail' || data.doc_status=='Uni_Auto_Approved'">
                  Genuine
                </td>
                <td *ngIf="data.doc_status=='UN_Rejected' ||  data.doc_status=='Uni_Auto_Rejected' ">
                  Fake 
                </td>
                <td>
                  <button class='action-btn bg-theme'  (click)="downloadPDF(data.application_id)"><i class="fa fa-download download-icon" aria-hidden="true"></i>
                    Download</button>
                </td>
              </tr>
              <div *ngIf="f.submitted && !f.valid">Please select</div>
            </tbody>
          </table>
        </div>
        <p class="dispute-link color-theme"><a data-toggle="modal" data-target="#disputeModal" (click)="getUserData()">Raise
            Dispute</a></p>
      </div>
      `
    </div>
  </div>

</div>

<div  *ngIf="appId!=undefined" class="modal fade" id="disputeModal" tabindex="-1" role="dialog" aria-labelledby="disputeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="disputeModalLabel">Raise Dispute</h5>
        <button type="button"  #closebuttonRemark class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="DisputeDataForm">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <label for="applicationId" class="form-label mb-0">Application Id</label>
                <span class="appId" id="application_id" name="application_id">{{appId}}</span>
              </div>
            </div>
          </div>
          <div class="row">
           
              <div class="form-group input-group col-md-12">
                <!-- <label for="phoneNumber" class="form-label">Your Phone Number</label>
                <input type="text" placeholder="Enter your Phone Number" name="phone_no"
                  [(ngModel)]="raiseDispute.phone_no" class="form-control form-input" id="phoneNumber"
                  value={{user_phone_no}}>
                <div class="invalid-feedback">
                  <div>Phone Number is required</div>
                </div> -->
                <label for="phoneNumber" class="form-label">Phone No. <span class="color-red">*</span></label>
                <div class="input-group-prepend">
                  <span class="input-group-text">+91</span>
                </div>
                <input type="text" placeholder="Enter your Phone no." formControlName="phoneNumber"   value={{user_phone_no}}
                  class="form-control form-input" id="phoneNumber" [(ngModel)]="raiseDispute.phone_no"
                  (keypress)="keyPress($event)" [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }" />
                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneNumber.errors.required">Phone No. is required</div>
                  <div
                    *ngIf="f.phoneNumber.errors.pattern || f.phoneNumber.errors.maxlength || f.phoneNumber.errors.minlength">
                    Phone number must be at least 10 numbers
                  </div>
                </div>
              </div>
          
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <!-- <label for="email" class="form-label">Your Email Id</label>
                  <input type="email" placeholder="Enter your Email Id" name="email" [(ngModel)]="raiseDispute.email" 
                  class="form-control form-input" id="email" value={{user_email}}>
                  <div class="invalid-feedback">
                      <div>Email is required</div>
                  </div> -->

                <label for="email" class="form-label">Your Email Id <span class="color-red">*</span></label>
                <input type="text" placeholder="Enter your Email" formControlName="email"
                  [(ngModel)]="raiseDispute.email" class="form-control form-input" id="email" value={{user_email}}
                  [pattern]="emailPattern" [ngClass]="{ 'is-invalid': submitted && f.email.invalid}"  />
                <div *ngIf="submitted &&  f.email.invalid" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">Email Id is required</div>
                  <div *ngIf="f.email.errors.pattern">Email must be a valid email address
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <!-- <label for="reason" class="form-label">Reason for Dispute</label>
                <textarea placeholder="Enter your reason for dispute" name="reason" [(ngModel)]="raiseDispute.reason"
                  class="form-control form-input" id="reason"></textarea>
                <div class="invalid-feedback">
                  <div>Reason is required</div>
                </div> -->

                <label for="reason" class="form-label">Reason for Dispute <span
                    class="color-red">*</span></label>
                <textarea placeholder="Enter your reason for dispute" formControlName="reason"
                  [(ngModel)]="raiseDispute.reason" class="form-control form-input"
                  id="reason" [ngClass]="{'is-invalid': submitted && f.reason.errors }" ></textarea>
                <div *ngIf="submitted && f.reason.errors" class="invalid-feedback">
                  <div *ngIf="f.reason.errors.required">Reason is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button class="approve-modal-btn bg-theme mr-auto" (click)="submitDispute()">Submit</button>
          <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
        </div>
      </form>
    </div>

  </div>
</div>
<ng-template  #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Success</h3>
          <p class="reset-hd2">Dispute Raised Successfully, Please check your mail.</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>
</ng-template>

<div  *ngIf="appId==undefined" class="modal fade" id="disputeModal" tabindex="-1" role="dialog" aria-labelledby="disputeModalLabel"  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="pleaseSelectModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Alert</h3>
          <p class="reset-hd2">Please select a record</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" >Ok</button>
    </div>
  </div>
</div>
</div>

<ng-template  #showErrorModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Failure</h3>
          <p class="reset-hd2">{{messageStr}}</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>
</ng-template>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>